import { IconButton, type IconButtonProps } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export type DialogCloseButtonProps = Omit<
  IconButtonProps,
  "aria-label" | "children" | "onClick"
> & {
  onClick: () => void;
};

export const DialogCloseButton = (props: DialogCloseButtonProps) => (
  <IconButton aria-label="close" {...props}>
    <CloseIcon />
  </IconButton>
);
